module.exports = __webpack_public_path__ + "static/media/lmsq-app-min.f74109a9.png";